<template>
  <ActionGeneric :to="to" label="Modifica" iconClass="fas fa-pen" :eventName="eventName" :btnClasses="btnClasses" :btnClassesMobile="btnClassesMobile" :disabled="disabled" />
</template>

<script>

import actionMixin from './mixins/action';

export default {
  name: 'action-edit',
  mixins: [actionMixin],
  components: {
    ActionGeneric: () => import('./ActionGeneric'),
  },
};

</script>
